import type { CopyAssets } from "./schema";

export interface PickedOnImageCopy {
  headline: string;
  subheadline?: string;
  badge?: string;
}

const OFFER_RE = /(\d{1,3}\s*%(\s*off)?|\$\s?\d|black\s*friday|\bbfcm\b|cyber\s*monday|\bxmas\b|christmas|holiday\s+sale|\bsale\b|\bdeal\b|free\s+(shipping|gift)|\bbogo\b|buy\s+one\b)/i;
const MOMENT_RE = /(black\s*friday|\bbf\b|\bbfcm\b|cyber\s*monday|\bxmas\b|christmas|new\s+year|valentine|mother'?s\s+day|father'?s\s+day|summer\s+sale|holiday)/i;

export function pickOnImageCopy(angle: {
  hookHeadline: string;
  copyAssets?: {
    adImage?: { headlines?: string[]; subheadlines?: string[]; badges?: string[] } | null;
  } | null;
}): PickedOnImageCopy {
  const H = (angle.copyAssets?.adImage?.headlines ?? []).filter((x): x is string => !!x?.trim());
  const S = (angle.copyAssets?.adImage?.subheadlines ?? []).filter((x): x is string => !!x?.trim());
  const B = (angle.copyAssets?.adImage?.badges ?? []).filter((x): x is string => !!x?.trim());

  const promoCampaign = [...H, ...S, ...B, angle.hookHeadline].some((t) => t && OFFER_RE.test(t));

  let badge = B[0];
  let headline = H[0] ?? angle.hookHeadline;
  let subheadline = S[0];

  if (promoCampaign) {
    const offerBadge = B.find((b) => OFFER_RE.test(b));
    if (offerBadge) badge = offerBadge;
    const offerCovered = OFFER_RE.test(headline) || (badge ? OFFER_RE.test(badge) : false);
    if (!offerCovered) {
      const offerHeadline = H.find((h) => OFFER_RE.test(h));
      if (offerHeadline) headline = offerHeadline;
    }
    const momentCovered = MOMENT_RE.test(headline) || (badge ? MOMENT_RE.test(badge) : false);
    if (!momentCovered) {
      const momentSub = S.find((s) => MOMENT_RE.test(s));
      if (momentSub) subheadline = momentSub;
    }
  }

  return { headline, subheadline, badge };
}

/** Keep old records readable while every new brief has one copy choice. */
export function singleCopyAssets(assets: CopyAssets, hookHeadline = assets.hookVariations?.[0] ?? ''): CopyAssets {
  const picked = pickOnImageCopy({ hookHeadline, copyAssets: assets });
  const one = (values: string[] | undefined) => (values ?? []).filter(v => v?.trim()).slice(0, 1);
  return {
    hookVariations: one(assets.hookVariations),
    adImage: { headlines: picked.headline ? [picked.headline] : [], subheadlines: picked.subheadline ? [picked.subheadline] : [], badges: picked.badge ? [picked.badge] : [] },
    meta: { primaryTexts: one(assets.meta?.primaryTexts), shortHeadlines: one(assets.meta?.shortHeadlines), descriptions: one(assets.meta?.descriptions) },
    ctaButtons: one(assets.ctaButtons),
  };
}
